import { Grid, TextField } from "@material-ui/core";
import { resetOnClick } from "helpers/resetOnClick";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { editSettlementStartRouteEndowment } from "redux/actions/routesStatus/routesStatusAction";

export const Dated = ({ block }) => {
  const { settlement } = useSelector(({ routesStatus }) => routesStatus);
  const dispatch = useDispatch();
  const { routes } = Object.keys(settlement).length > 0 && settlement;
  const { start } = routes;
  const { cil20, cil30, cil45, cil10 } = start.endowments;

  const handleStartEndowments = ({ target }) => {
    const value = target.value == "" ? 0 : parseFloat(target.value);

    if (isNaN(value)) return;
    dispatch(editSettlementStartRouteEndowment(target.name, value));
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={3}>
        <TextField
          label="De 10:"
          margin="dense"
          variant="outlined"
          fullWidth
          name="cil10"
          value={cil10}
          disabled={block}
          onChange={handleStartEndowments}
          InputProps={{ inputProps: { min: 0, right: "1" } }}
          onFocus={() => resetOnClick(handleStartEndowments, cil10, "cil10")}
        />
      </Grid>{" "}
      <Grid item xs={12} md={3}>
        <TextField
          label="De 20:"
          margin="dense"
          variant="outlined"
          fullWidth
          name="cil20"
          value={cil20}
          disabled={block}
          onChange={handleStartEndowments}
          InputProps={{ inputProps: { min: 0, right: "1" } }}
          onFocus={() => resetOnClick(handleStartEndowments, cil20, "cil20")}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="De 30:"
          margin="dense"
          variant="outlined"
          fullWidth
          name="cil30"
          value={cil30}
          disabled={block}
          onChange={handleStartEndowments}
          InputProps={{ inputProps: { min: 0, right: "1" } }}
          onFocus={() => resetOnClick(handleStartEndowments, cil30, "cil30")}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="De 45:"
          margin="dense"
          variant="outlined"
          fullWidth
          name="cil45"
          value={cil45}
          disabled={block}
          onChange={handleStartEndowments}
          InputProps={{ inputProps: { min: 0, right: "1" } }}
          onFocus={() => resetOnClick(handleStartEndowments, cil45, "cil45")}
        />
      </Grid>
    </Grid>
  );
};
